/* eslint-disable */

import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { getEmpresaSelecionada } from '../util/empresaSelecionada';
import qs from 'qs';
import { getEmpresas } from '../security/securityContext';
import alterarEmpresaSelecionada from '../actions/empresa/alterarEmpresaSelecionada'

export class AuthenticatedRoute extends Component {
  renderComponent (isAuthenticated, Component) {
    return props => {
      if (!isAuthenticated) {
        return (<Redirect
          to={{
            pathname: '/login',
            state: { from: props.location }
          }}
        />)
      }

      const parametros = qs.parse(props.location.search, { ignoreQueryPrefix: true });
      if(parametros && parametros.empresa){
        const empresas = getEmpresas();
        const empresa = empresas.filter(empresa => empresa.id == parametros.empresa)[0];
        this.props.alterarEmpresaSelecionada(empresa);
      }

      const empresaSelecionada = getEmpresaSelecionada();


      if (!empresaSelecionada && props.location.pathname !== '/selecao-empresa' && props.location.pathname !== '/') {
        return <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      }

      return (<Component {...props} />)
    }
  }

  render () {
    const { isAuthenticated, component: Component, ...rest } = this.props;
    return (<Route {...rest} render={this.renderComponent(isAuthenticated, Component)}/>)
  }
}

const mapStateToProps = ({ authentication: { isAuthenticated } }) => ({ isAuthenticated });

export default connect(mapStateToProps, { alterarEmpresaSelecionada })(AuthenticatedRoute)
